import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

export const fetchAllFeedback = createAsyncThunk(
  "feedback/fetchAllFeedback",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/feedBack`);
      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // The server returns 404 when there is no data
        return [];
      }
      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddFeedback = createAsyncThunk(
  "feedback/AddFeedback",
  async ({ data }, { rejectWithValue }) => {
    // console.log(data)
    try {
      // console.log(selectedSuperCategoryId)
      // console.log(" Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      // console.log("Sending Category with FormData...");

      const createResponse = await axios.post(`${BASE_URL}/feedBack`, data, {
        headers: {
          token,
        },
      });

      // console.log(" Brand created with image:", createResponse.data);

      return createResponse.data.data;
    } catch (error) {
      console.error("AddfeedBack failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add feedBack");
    }
  }
);

export const deleteFeedbackById = createAsyncThunk(
  "feedback/deleteFeedbackById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/feedBack/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log("Category deleted:", response.data);

      // Can we return the id to update the state in the reducer?
      return id;
    } catch (error) {
      console.error("❌ Delete failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to delete feedBack"
      );
    }
  }
);

export const updateFeedbackById = createAsyncThunk(
  "feedback/updateFeedbackById",
  async ({ id, data }, { rejectWithValue }) => {
    // console.log(data);
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.put(`${BASE_URL}/feedBack/${id}`, data, {
        headers: {
          token: token,
        },
      });

      return response.data || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update feedBack"
      );
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedBack",
  initialState: {
    allFeedback: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.allFeedback = action.payload;
      })
      .addCase(fetchAllFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default feedbackSlice.reducer;

// Export actions and reducer
